export const ingredientsBloodmoon = [
    {
        name: 'Bear Pelt',
        effects: [
            'Drain Fatigue',
            'Fortify Strength',
            'Resist Common Disease',
            'Night Eye'
        ],
        value: 2,
        weight: 1.0
    },
    {
        name: 'Bristleback Leather',
        effects: ['Blind', 'Frost Damage', 'Resist Frost', 'Recall'],
        value: 2,
        weight: 1.0
    },
    {
        name: 'Grahl Eyeball',
        effects: [
            'Resist Frost',
            'Night Eye',
            'Drain Magicka',
            'Fortify Strength'
        ],
        value: 15,
        weight: 1.0
    },
    {
        name: 'Gravetar',
        effects: ['Resist Frost', 'Drain Health', 'Fortify Fatigue', 'Drain Luck'],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Heartwood',
        effects: [
            'Restore Magicka',
            'Fortify Agility',
            'Drain Strength',
            'Weakness to Fire'
        ],
        value: 200,
        weight: 1.0
    },
    {
        name: 'Holly Berries',
        effects: [
            'Resist Frost',
            'Frost Shield',
            'Frost Damage',
            'Weakness to Fire'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Horker Tusk',
        effects: [
            'Drain Alteration',
            'Fortify Intelligence',
            'Fortify Maximum Magicka',
            'Detect Animal'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Raw Stalhrim',
        effects: ['Resist Frost', 'Frost Damage', 'Paralyze', 'Restore Health'],
        value: 300,
        weight: 5.0
    },
    {
        name: 'Ripened Belladonna Berries',
        effects: [
            'Resist Magicka',
            'Restore Magicka',
            'Fortify Magicka',
            'Drain Magicka'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Snow Bear Pelt',
        effects: [
            'Drain Fatigue',
            'Fortify Speed',
            'Resist Common Disease',
            'Night Eye'
        ],
        value: 2,
        weight: 1.0
    },
    {
        name: 'Snow Wolf Pelt',
        effects: [
            'Drain Fatigue',
            'Fortify Speed',
            'Resist Common Disease',
            'Night Eye'
        ],
        value: 2,
        weight: 1.0
    },
    {
        name: 'Unripened Belladonna Berries',
        effects: [
            'Resist Magicka',
            'Restore Magicka',
            'Fortify Magicka',
            'Drain Magicka'
        ],
        value: 5,
        weight: 0.1
    },
    {
        name: 'Wolf Pelt',
        effects: [
            'Drain Fatigue',
            'Fortify Speed',
            'Resist Common Disease',
            'Night Eye'
        ],
        value: 2,
        weight: 1.0
    },
    {
        name: 'Wolfsbane Petals',
        effects: [
            'Restore Intelligence',
            'Invisibility',
            'Drain Endurance',
            'Drain Magicka'
        ],
        value: 5,
        weight: 0.1
    }
].map(it => ({
    ...it,
    isBloodmoon: true
}));
